module.exports = {"attributes":{"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"},"content":"<text class='channel-icon-logo' style=\"white-space: pre; font-family: Arial, sans-serif; font-weight: 700; font-size: 160px;\" x=\"-6.518\" y=\"156.841\" transform=\"matrix(0.837991, 0, 0, 1, 6.521582, -4.04751)\">NA</text>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/type_.svg
// module id = 1367
// module chunks = 0